// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */

/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 图形监督设置
import graphics from '@/views/system/graphics';

// 个人中心
import personalCenter from '@/views/system/personalCenter';
import messageBoard from '@/views/message/board';
import messageCenter from '@/views/message/messageCenter';
import messageDetails from '@/views/message/messageDetails';

/**
 * 基础数据
 */
import Employee from '@/views/basicData/employee';
import Department from '@/views/basicData/department';
import DeptUser from '@/views/basicData/deptUser';

/**
 * 在线培训管理
 */
import classification from '../views/onlineTraining/classification'; //  科目类别字典
import course from '../views/onlineTraining/course/course.vue'; //  培训课程
import reviewManagement from '../views/onlineTraining/course/reviewManagement.vue'; //  评论管理
import overview from '../views/onlineTraining/overview'; //  培训总览
import courseLearningRecords from '../views/onlineTraining/course/courseLearningRecords.vue'; //  培训课程-学习记录
import annualPlan from '../views/onlineTraining/annualPlan'; //  年度计划
import annualPlanDept from '../views/onlineTraining/annualPlanDept'; //  年度计划
import creditHourStatistics from '../views/onlineTraining/creditHourStatistics'; //  学时统计
import trainingPlan from '../views/onlineTraining/trainingPlan/trainingPlan.vue'; //  培训任务
import categories from '../views/onlineTraining/trainingPlan/categories.vue'; //  培训任务
import statisticsIndex from '../views/onlineTraining/statistics/index.vue'; //  培训统计表
import statisticsDetails from '../views/onlineTraining/statistics/details.vue'; //  培训统计表-详情
import Trainers from '../views/onlineTraining/trainingPlan/Trainers'; //  培训任务-培训人员
import TrainersLearningRecords from '../views/onlineTraining/trainingPlan/TrainersLearningRecords'; //  培训任务-学习记录
import participationTrain from '../views/participationTrain/index'; //  参加培训计划
import participationCourse from '../views/participationTrain/course'; //  参加培训计划-课程
import participationCourseDetail from '../views/participationTrain/courseDetail'; //  参加培训计划-课程详情

// 线下培训计划
import offlineTrainingList from '../views/offlineTraining/list.vue'; //  培训任务

/**
 * 题库考试
 */
import topicVendor from '../views/training/topicVendor'; //  题库管理
import keys from '../views/training/keys'; //  关键字管理
import examination from '../views/training/examination'; //  试卷管理
import examinationRecord from '../views/training/examinationRecord'; //  考试记录
import statistics from '../views/training/statistics'; //  考试统计

// 权限管理
import notFound from '@/components/error.vue';
import home from '@/views/home.vue';
import template from '@/components/template.vue';

// pc端答题
import exercise from '@/views/participation/exercise'; // 练习
import underway from '@/views/participation/underway'; // 进行中
import exam from '@/views/participation/exam'; // 考试
import errorSetList from '@/views/errorSet/list'; // 错题集
import errorSetTrain from '@/views/errorSet/train'; // 错题训练



// 启用路由
Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/notFound',
        name: '页面找不到啦',
        component: notFound,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
            {
                path: '/home',
                name: '首页',
                component: home,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/system/user',
                name: '用户管理',
                component: user,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Module',
                name: '菜单管理',
                component: Module,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Role',
                name: '角色管理',
                component: Role,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/system/graphics',
                name: '图形监督设置',
                component: graphics,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/system/personalCenter',
                name: '个人中心',
                component: personalCenter,
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/basic/Employee',
                name: '人员档案管理',
                component: Employee,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/basic/Department',
                name: '机构部门管理',
                component: Department,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/basic/DeptUser',
                name: '部门人员',
                component: DeptUser,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/onlineTraining/classification',
                name: '科目类别字典',
                component: classification,
                meta: { requireAuth: true }
            }, {
                path: '/onlineTraining/course',
                name: '培训课程',
                component: course,
                meta: { requireAuth: true }
            }, {
                path: '/onlineTraining/reviewManagement',
                name: '评论管理',
                component: reviewManagement,
                meta: { requireAuth: true }
            },

            {
                path: '/onlineTraining/overview',
                name: '培训总览',
                component: overview,
                meta: { requireAuth: true }
            },

            {
                path: '/onlineTraining/courseLearningRecords',
                name: '培训课程-学习记录',
                component: courseLearningRecords,
                meta: { requireAuth: true }
            },
            {
                path: '/onlineTraining/annualPlanDept',
                name: '年度计划',
                component: annualPlanDept,
                meta: { requireAuth: true }
            },
            {
                path: '/onlineTraining/annualPlan',
                name: '年度计划',
                component: annualPlan,
                meta: { requireAuth: true }
            },
            {
                path: '/onlineTraining/creditHourStatistics',
                name: '学时统计',
                component: creditHourStatistics,
                meta: { requireAuth: true }
            },
            {
                path: '/onlineTraining/statistics/Index',
                name: '培训记录表',
                component: statisticsIndex,
                meta: { requireAuth: true }
            },
            {
                path: '/onlineTraining/statistics/details',
                name: '培训记录表-详情',
                component: statisticsDetails,
                meta: { requireAuth: true }
            },
            {
                path: '/onlineTraining/trainingPlan',
                name: '培训任务',
                component: trainingPlan,
                meta: { requireAuth: true }
            }, {
                path: '/onlineTraining/Trainers',
                name: '培训任务-培训人员',
                component: Trainers,
                meta: { requireAuth: true }
            }, {
                path: '/onlineTraining/TrainersLearningRecords',
                name: '培训任务-学习记录',
                component: TrainersLearningRecords,
                meta: { requireAuth: true }
            }, {
                path: '/onlineTraining/categories',
                name: '培训任务-任务分类管理',
                component: categories,
                meta: { requireAuth: true }
            },
            {
                path: '/participation/train',
                name: '参加培训计划',
                component: participationTrain,
                meta: { requireAuth: true }
            }, {
                path: '/participation/course',
                name: '参加培训计划-课程',
                component: participationCourse,
                meta: { requireAuth: true }
            }, {
                path: '/participation/courseDetail',
                name: '参加培训计划-课程',
                component: participationCourseDetail,
                meta: { requireAuth: true }
            }, {
                path: '/training/topicVendor',
                name: '题库管理',
                component: topicVendor,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/training/keys',
                name: '关键字管理',
                component: keys,
                meta: {
                    requireAuth: true
                }
            },{
                path: '/training/examination',
                name: '试卷管理',
                component: examination,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/training/examinationRecord',
                name: '考试记录',
                component: examinationRecord,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/training/statistics',
                name: '考试统计',
                component: statistics,
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/participation/exercise',
                name: '练习',
                component: exercise,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/participation/underway',
                name: '考试/练习进行中',
                component: underway,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/errorSet/list',
                name: '错题集',
                component: errorSetList,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/errorSet/train',
                name: '错题训练',
                component: errorSetTrain,
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/participation/exam',
                name: '考试',
                component: exam,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/message/board',
                name: '留言板',
                component: messageBoard,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/message/messageCenter',
                name: '消息中心',
                component: messageCenter,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/message/messageDetails',
                name: '消息中心-详情',
                component: messageDetails,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/offlineTraining/list',
                name: '线下培训计划',
                component: offlineTrainingList,
                hidden: true,
                meta: {
                    requireAuth: false
                }
            },
            {
                path: '/system/template',
                name: 'moban',
                component: template,
                hidden: true,
                meta: {
                    requireAuth: false
                }
            },


        ]
    },
    {
        hidden: true,
        path: '*',
        component: notFound
    },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js